/* RESPONSIBLE TEAM: team-self-serve */
import { get } from 'embercom/lib/ajax';

export interface DiscountDefinition {
  id: number;
  name: string;
  plan_id: string;
  usage_agreement_name: string;
  discount_type: 'percentage' | 'fixed';
  discount_value: number;
}

export interface Campaign {
  id: number;
  name: string;
  description: string;
  campaign_type: string;
  claim_type: string;
  valid_for_claiming_in_days: number | null;
  discount_duration_in_months: number | null;
  lookup_key: string | null;
  logo_url: string | null;
  is_active: boolean;
  is_force_stopped: boolean;
  created_at: string;
  updated_at: string;
  claim_limit_reached: boolean;
  discount_definitions: DiscountDefinition[];
}

export interface CustomerCampaign {
  campaign_id: number;
  lookup_key: string;
  campaign_type: string;
  redeemed: boolean;
  redemption_expires_at: string;
  discount_finishes_at: string;
}

export function isCoreSeatDiscount(dd: DiscountDefinition): boolean {
  return dd.usage_agreement_name === 'core_seats';
}

export function hasPlanId(dd: DiscountDefinition): boolean {
  return dd.plan_id !== null;
}

export async function fetchCustomerCampaignByLookupKey(
  appId: string,
  lookupKey: string,
): Promise<Campaign | null> {
  try {
    let response = await get('/ember/billing/customer_campaign_by_lookup_key', {
      app_id: appId,
      lookup_key: lookupKey,
    });
    return response.campaign;
  } catch {
    return null;
  }
}
